import { render } from "./HeroiconsSolidPhoneOutgoing.vue?vue&type=template&id=ed472072"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneOutgoing.vue"]])

export default __exports__